export default __webpack_public_path__ + "static/media/kevin-song.da04ea1c.png";